// import { UserService, AuthenticationError } from '../../services/user.service'
// import { TokenService } from '../../services/storage.service'
// import router from '../../router'

import ApiService from "@/services/api.service";
// import TokenService from "@/services/storage.service";


const state = {
    id: null,
    name: null,
    avatar: null,
    quizzes: null,
    gifts: null
}

const getters = {
    logged_user: (state) => {
        return state
    }
}

const actions = {}

const mutations = {
    update_profile(state, user) {
        state.id = user.id
        state.name = user.name
        state.avatar = user.avatar
        state.quizzes = user.quizzes
        state.gifts = user.gifts
    },

    update_avatar_src(state, avatar_src) {
        state.avatar = avatar_src
    },

    decrement_gift(state, id) {
        console.log(id);
        let gift = state.gifts.find(gift => Number(gift.id) === Number(id))
        console.log(gift.availability);
        if(gift && gift.availability>0){
            gift.availability--;
            console.log(gift.availability);
        }else{
            this.commit('snack_bar/snack_bar_fire',{type:'error',message:'Подаръкът не е наличен'})
        }

    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
